import { Component, OnInit } from '@angular/core';
import { SharingDataService } from '../../../shared/services/sharingData/sharing-data.service';
import { IMinimumPaymtCalSharedData } from '../../models/minimumPaymtCalSharedData.model';
import { ConfigData } from '../../models/configData.model';
import { CardService } from '../../../shared/services/card/card.service';
import { IAprInputData } from '../../models/aprInputData.model';
import { IRequestG } from '../../models/dtos/requestG.model';
import { CalculatorService } from '../../../shared/services/calculator/calculator.service';
import { Router } from '@angular/router';
import { JsonDetails } from 'src/app/models/jsonDetails.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.css'],
  providers: [DatePipe]
})
export class CardInfoComponent implements OnInit {
  creditLimit: string;
  selectedCard: string;
  minPayment: string;
  balancePayOff: string;
  aprValue: string;
  tawarruqFee: string;
  annualFee: string;
  calculatedAnnualFee: string;
  cardImgUrl: string;
  isSuccess: boolean;
  errorMessage: string;
  configurations: ConfigData;
  minimumPaymtCalSharedData: IMinimumPaymtCalSharedData;
  translatedData :JsonDetails;
  CalculationDate: string;
  CalculationDateInfo: string;
  CalculationDateInfoAr: string="***تم احتساب معدل الفائدة السنوية المذكور اعلاه باعتبار تاريخ الموافقة على البطاقة <today_Date>";
  CalculationDateInfoEn: string="***The APR computation is assuming <today_Date> as the Card allotment/approval date.";
  language: string;
  hideApplyOnline: boolean;


  constructor(public sharingDataService: SharingDataService, private cardService: CardService, private calculatorService: CalculatorService, private router: Router, private datePipe: DatePipe) {
  }

  ngOnInit(): void {
    const date = new Date();
    this.CalculationDate = this.datePipe.transform(date, 'dd-MMM-yyyy');
    this.getLanguage();
    this.getConfigDetails();
    this.getMinimumPaymtCalSharedData();
    this.getAPR(); 
  }

  getLanguage() {
    this.language = this.cardService.getLanguage();
    if(this.language.toLowerCase().trim() == 'en') {
      this.CalculationDateInfo = this.CalculationDateInfoEn.replace("<today_Date>",this.CalculationDate); 
    } else {
      this.CalculationDateInfo = this.CalculationDateInfoAr.replace("<today_Date>",this.CalculationDate);     
    }
  }

  getConfigDetails() {
    this.translatedData =  this.sharingDataService.minimumPaymtCalSharedData.TranslatedData;
    this.configurations = this.cardService.getConfigInfo();
  }

  getMinimumPaymtCalSharedData(): void {
    this.minimumPaymtCalSharedData = this.sharingDataService.minimumPaymtCalSharedData;
  }

  getAPR() {    
    if (this.configurations && this.minimumPaymtCalSharedData.SelectedCard) {     

      let aprInputData: IAprInputData = {
        MinPayment: this.configurations.MinPayment,
        MurabahaRate: this.configurations.MurabahaRate,
        UserEnteredAmount: this.minimumPaymtCalSharedData.DesiredCreditLimit,
        CalculatedAnnualFee : this.minimumPaymtCalSharedData.SelectedCard.CalculatedAnnualFee
      };

      let url = "api/CreditCardPaymentCalc/getAPR";
      let calDataGetReq: IRequestG<IAprInputData> = { Body: aprInputData };
      this.calculateAPR(url, calDataGetReq);
    }
    else {
      this.isSuccess = false;
      this.errorMessage = this.translatedData.ErrorList.find(e => e.Id=="GenericError").Text;
    }
  }

  calculateAPR(url: string, calDataGetReq: IRequestG<IAprInputData>) {
    this.calculatorService.getDataCalculatorPage(url, calDataGetReq).subscribe(
      (data) => {
        if (data != null) {
          this.hideApplyOnline = false;
          if (data.Error.ErrorCode == '000') {
//            this.balancePayOff = data.Body.NumberOfMonths.toString() + ' Months'; 
            this.balancePayOff = data.Body.NumberOfMonths.toString() + " " + $localize`:@@months:months`;; 
            this.aprValue = data.Body.AprValue.toString() + '%';    
            this.selectedCard = this.minimumPaymtCalSharedData.SelectedCard.Name;
            this.hideApplyOnline = this.minimumPaymtCalSharedData.SelectedCard.Id==24;
            this.minPayment = this.configurations.MinPaymentPer + '%';
            this.tawarruqFee = this.configurations.MurabahaRate + '%';
            this.cardImgUrl = this.minimumPaymtCalSharedData.SelectedCard.SelectionImage;

            this.creditLimit =  this.minimumPaymtCalSharedData.SelectedCard.CardCurrency.toString() +' '+ this.minimumPaymtCalSharedData.DesiredCreditLimit.toString();
            this.annualFee =  this.minimumPaymtCalSharedData.SelectedCard.CardCurrency.toString() +' '+ this.minimumPaymtCalSharedData.SelectedCard.AnnualFee.toString();
            this.isSuccess = true;        
          }
          else {
            this.isSuccess = false;
            this.errorMessage = this.translatedData.ErrorList.find(e => e.Id=="CardInfoCalculationError").Text;
          }
          this.calculatedAnnualFee = this.minimumPaymtCalSharedData.SelectedCard.CardCurrency.toString() +' '+ this.minimumPaymtCalSharedData.SelectedCard.CalculatedAnnualFee.toString();
        }
        else {
          this.isSuccess = false;
          this.errorMessage = this.translatedData.ErrorList.find(e => e.Id=="CardInfoCalculationError").Text;
        }
      },
      (err) => {
        this.isSuccess = false;
        this.errorMessage = this.translatedData.ErrorList.find(e => e.Id=="GenericError").Text;
      }
    );

  }
  backToHome() {
    this.sharingDataService.minimumPaymtCalSharedData.DesiredCreditLimit = 0;
    this.sharingDataService.minimumPaymtCalSharedData.Nationality = true;
    this.sharingDataService.minimumPaymtCalSharedData.MonthlyIncome = 0;
    this.sharingDataService.minimumPaymtCalSharedData.SelectedCard = null,
    this.sharingDataService.minimumPaymtCalSharedData.DesiredCreditLimit = 0;
    this.sharingDataService.minimumPaymtCalSharedData.TranslatedData = null;
    this.router.navigate(['/recommendation']);
  }

}
